import moment from 'moment';

if($('#basic-import-component').length){
    var app = new Vue({
        el: '#basic-import-component',
        data: {
            csv:'',
            json:[],
            forceOverwrite:false,
            notifyUsers:true,
            universitySlug:'',
            networkSlug:'',
            client:''
        },
        methods: {
            previewCSV(event) {
                this.json = JSON.parse(this.csv);
            },
            importRecords(i){
                if(this.client){
                    if(i > 0 || confirm("Do you really want to upload "+this.json.length+" innovations?")){
                        var recordsMax = this.json.length;
                        if(i < recordsMax){
                            axios.post('/api/v1/import/basic?forceOverwrite='+this.forceOverwrite+'&notifyUsers='+this.notifyUsers+'&universitySlug='+this.universitySlug+'&networkSlug='+this.networkSlug+'&client='+this.client, this.json[i])
                            .then((response) =>  {
                                console.log(response);
                                this.json[i].uploadStatus = response.data;
                                this.$nextTick(() => {
                                    this.notifyUsers = !this.notifyUsers; 
                                    this.notifyUsers = !this.notifyUsers; 
                                });
                                i++;
                                this.importRecords(i);
                            })
                            .catch((error) =>  {
                                console.log(error);
                                this.json[i].uploadStatus = 'failed';
                                this.$nextTick(() => {
                                    this.notifyUsers = !this.notifyUsers; 
                                    this.notifyUsers = !this.notifyUsers; 
                                });
                                i++;
                                this.importRecords(i);
                            });
                        }
                    }
                }else{
                    alert('add client name');
                }
            }
        },
        mounted () {
        }
    });
}